import { AuthenticationResult } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Button } from "@material-ui/core";
import React, { type FormEvent, type FormEventHandler } from "react";
import { MESApiService } from "../../../services";
import { AuthContext } from "../../AuthProvider";
import { loginRequest } from "./AzureADAuthConfig";

export const LoginWithAzureADForm = () => {
	const { saveUserData } = React.useContext(AuthContext);
	const { instance } = useMsal();
	const login: FormEventHandler = async (e: FormEvent) => {
		e.preventDefault();
		try {
			const result: AuthenticationResult =
				await instance.loginPopup(loginRequest);

			const api = new MESApiService();
			try {
				const loginResponse = await api.loginWithAzureAD(result.accessToken);
				saveUserData(loginResponse);
			} catch (e) {
				console.log(e);
			}
		} catch (e) {
			console.log({ e });
		}
	};

	return (
		<form onSubmit={login}>
			{/*<Alert show={showError} variant="danger" dismissible={true} onClose={() => {*/}
			{/*    setShowError(false);*/}
			{/*    setError(undefined)*/}
			{/*}}>*/}
			{/*    <strong>Bad credentials</strong>*/}
			{/*    <p> {error === undefined ? 'There was an error' :*/}
			{/*        (error.internalError.message === undefined ? error.internalError : error.internalError.message)}*/}
			{/*    </p>*/}
			{/*</Alert>*/}
			<div className="row">
				<Button
					fullWidth
					variant="contained"
					style={{ backgroundColor: "#479DC4", color: "white" }}
					type="submit"
				>
					Login with Azure AD
				</Button>
			</div>
		</form>
	);
};
